var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a885931aaf4ab8ae3013b0dfda3a2cc6a26b4161"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["storefront@otovo"]={id:"a885931aaf4ab8ae3013b0dfda3a2cc6a26b4161"};
      